import { render, staticRenderFns } from "./CaseDetails.vue?vue&type=template&id=a7f0124c&scoped=true&"
import script from "./CaseDetails.vue?vue&type=script&lang=js&"
export * from "./CaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetails.vue?vue&type=style&index=0&id=a7f0124c&scoped=true&lang=css&"
import style1 from "./CaseDetails.vue?vue&type=style&index=1&id=a7f0124c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f0124c",
  null
  
)

export default component.exports